import { render } from "./WelcomeMessages.vue?vue&type=template&id=0529a242&ts=true"
import script from "./WelcomeMessages.vue?vue&type=script&lang=ts"
export * from "./WelcomeMessages.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__